import { Form } from 'react-final-form';
import { useTranslation } from '../../../utils/useTranslation';
import { Flex } from '../../layout/Flex';
import { Spin } from '../../layout/Spin/Spin';
import { Typography } from '../../typography/Typography';
import { PartnerTypeTabs } from '../PartnerTypeTabs/PartnerTypeTabs';
import { ErrorMessage } from './components/ErrorMessage';
import { fieldsMap } from './constants';
import { PartnerRegistrationFromFields } from './parts/PartnerRegistrationFromFields';
import { ActionButton, ActionButtonWrapper } from './styles';
import { PartnerRegistrationFormProps } from './types';

export const PartnerRegistrationForm = ({
    initialValues,
    onSubmit,
    partnerType,
    onPartnerTypeChange,
    isLoading,
    errorMessage,
    fieldErrors,
}: PartnerRegistrationFormProps) => {
    const t = useTranslation();

    return (
        <>
            <Typography variant="title3" weight="medium">
                {t('Данные для договора')}
            </Typography>
            <Typography variant="body" weight="medium" pt={2} pb={1}>
                {t('Тип сотрудничества')}
            </Typography>
            <PartnerTypeTabs partnerType={partnerType} onChange={onPartnerTypeChange} />
            <Form
                onSubmit={onSubmit}
                initialValues={initialValues}
                render={({ handleSubmit, invalid, pristine }) => (
                    <Flex as="form" width="100%" height="100%" onSubmit={handleSubmit}>
                        <PartnerRegistrationFromFields
                            fields={fieldsMap[partnerType]}
                            errors={fieldErrors}
                        />
                        <ActionButtonWrapper>
                            <ActionButton
                                type="submit"
                                onClick={handleSubmit}
                                size="l"
                                disabled={invalid || pristine}
                            >
                                {isLoading ? (
                                    <Spin color="var(--color-invert)" size={20} />
                                ) : (
                                    t('Далее')
                                )}
                            </ActionButton>
                            <ErrorMessage message={errorMessage} />
                        </ActionButtonWrapper>
                    </Flex>
                )}
            />
        </>
    );
};
